<template>
    <div class="table">
            <div class="container" 
                element-loading-background = "rgba(255, 255,255,0.7)"
                :element-loading-text = "loadingText"
                v-loading="loading"  style="width:95%;">

                <el-form ref="form" :model="form" label-width="110px" style="height:80px;">
                    
                    <el-form-item   label="学校切换">
                        <el-select v-model="form.deptId" placeholder="请选择学校" 
                                    @change="getData">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-form>
                <span slot="footer" class="dialog-footer" style="text-align:left;">
                    <el-button type="danger" round @click="clear()">学生兑换积分清零</el-button>
                    <el-button type="danger" round v-if="form.shopSign == 1" @click="update(0)">关闭积分商城兑换</el-button>
                    <el-button type="primary" round v-if="form.shopSign == 0" @click="update(1)">开启积分商城兑换</el-button>
                    <el-button type="primary" round   @click="updateDict()">积分和金币兑换比率设置</el-button>
                </span>
            </div>
        <!-- 积分和金币兑换比率设置弹出框 -->
        <div v-if="goldCoinExchangesetVisible">
            <goldCoinExchangeset ref="goldCoinExchangeset"></goldCoinExchangeset>
        </div>
    </div> 
</template>

<script>
    import http from '../../../../common/http'; 
    import goldCoinExchangeset from './GoldCoinExchangeset.vue'; 

    export default {
        name:"",
        data(){
            return{
                loading:false,
                loadingText:"",
                goldCoinExchangesetVisible:false,

                form:{
                    deptId:"",
                    shopSign:0,
                    tempSign:0,
                    opertName:""
                },
                depts:[],
            }
        },
        components: {
            goldCoinExchangeset
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.setcommonParamListUrl;
                let data = {
                    deptId:this.form.deptId
                };

                // console.log(JSON.stringify(data));
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        if(res.data !=null){
                           this.form.shopSign=res.data.paramValue;
                        }else{
                           this.form.shopSign=0;
                        }
                        console.log(this.form.shopSign);
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            }, 
            clear(){ // 学生兑换积分清零
                let school="";
                for(let i=0;i<this.depts.length;i++){
                    let dept=this.depts[i];
                    if(this.form.deptId == dept.id){
                        school=dept.name;
                    }
                }
                // console.log(school);
                this.$commonFn.showConfirm2('积分清零会将【'+school+'】本学期所有学生兑换积分、已兑换的金币、课堂积分都清零，是否继续？',this.clearSuccess);
            },
            clearSuccess(){
                this.loading=true;
                this.loadingText="积分清零中...";

                let url = this.setcommonParamClearUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            update(shopSign){ //开启与关闭积分商城
                let name="";
                // shopSign：1-开启；0-关闭
                if(shopSign == 1){
                    this.form.opertName = '开启积分商城兑换';
                }else if(shopSign == 0){
                    this.form.opertName = '关闭积分商城兑换';
                }
                this.form.tempSign=shopSign;
                this.$commonFn.showConfirm2('本学期将'+this.form.opertName+'，是否继续？',this.updateSuccess);
            },
            updateSuccess(){
                this.loading=true;
                this.loadingText=this.form.opertName+"中...";

                let url = this.setcommonParamSaveUrl;
                let data = {
                    deptId:this.form.deptId,
                    paramValue:this.form.tempSign
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            updateDict(){
                this.goldCoinExchangesetVisible=true;
                this.$nextTick(() => { 
                    this.$refs['goldCoinExchangeset'].init(this.form.deptId);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/studentSet/CommonSet.vue